import { styled } from 'styled-components';

const FlexBoxVertical = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;
export default FlexBoxVertical;
